export default __webpack_public_path__ + "68b381a2f7596b783b344c9aa863bb64.svg";